var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"spacer",attrs:{"id":"support"}},[_c('div',{staticClass:"title big"},[_vm._v(_vm._s(_vm.support.title))]),_c('div',{staticClass:"pt big",domProps:{"innerHTML":_vm._s(_vm.support.textarea)}})])}
var staticRenderFns = []

export { render, staticRenderFns }